module.exports = __webpack_public_path__ + "static/pic01@4xwebp-dd8e7fc241e98a55bc9bab0c1b6e7550.webp";